module.exports = __webpack_public_path__ + "img/07-W.e9d81c80.svg";